import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { X } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface PrivacyPolicyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PrivacyPolicyModal({ open, onOpenChange }: PrivacyPolicyModalProps) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-full h-full sm:max-w-full sm:h-full sm:rounded-none p-0 gap-0">
        <DialogHeader className="p-4 border-b sticky top-0 bg-background z-10">
          <div className="flex items-center justify-between">
            <DialogTitle>{t('consentModalTitle')}</DialogTitle>
            <DialogClose className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
              <X className="h-5 w-5" />
              <span className="sr-only">Close</span>
            </DialogClose>
          </div>
        </DialogHeader>
        <ScrollArea className="flex-1 h-[calc(100dvh-80px)]">
          <div className="p-6 space-y-4 text-sm text-muted-foreground">
            <h2 className="text-lg font-semibold text-foreground">{t('consentTitle')}</h2>
            
            <p>{t('consentIntro')}</p>
            
            <h3 className="text-base font-medium text-foreground mt-6">{t('consentOperator')}</h3>
            <p>{t('consentOperatorIntro')}</p>
            <div className="mt-2 space-y-1">
              <p><span className="font-medium text-foreground">{t('consentCompanyName')}</span> tugedr s.r.o.</p>
              <p><span className="font-medium text-foreground">{t('consentAddress')}</span> Súkennícka 19058/1 Bratislava - mestská časť Ružinov 821 09</p>
              <p><span className="font-medium text-foreground">{t('consentRegNumber')}</span> 52 813 282</p>
              <p><span className="font-medium text-foreground">{t('consentEmail')}</span> peter@tugedr.com</p>
            </div>
            
            <h3 className="text-base font-medium text-foreground mt-6">{t('consentScope')}</h3>
            <p>{t('consentScopeIntro')}</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>{t('consentScopeEmail')}</li>
              <li>{t('consentScopeNickname')}</li>
              <li>{t('consentScopeUsage')}</li>
            </ul>
            
            <h3 className="text-base font-medium text-foreground mt-6">{t('consentPurpose')}</h3>
            <p>{t('consentPurposeIntro')}</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>{t('consentPurposeAccount')}</li>
              <li>{t('consentPurposeApp')}</li>
              <li>{t('consentPurposeImprove')}</li>
            </ul>
            
            <h3 className="text-base font-medium text-foreground mt-6">{t('consentDuration')}</h3>
            <p>{t('consentDurationIntro')}</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>{t('consentDurationAccount')}</li>
              <li>{t('consentDurationRevoke')}</li>
            </ul>
            
            <h3 className="text-base font-medium text-foreground mt-6">{t('consentRights')}</h3>
            <p>{t('consentRightsIntro')}</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>{t('consentRightsAccess')}</li>
              <li>{t('consentRightsCorrect')}</li>
              <li>{t('consentRightsRestrict')}</li>
              <li>{t('consentRightsPortability')}</li>
              <li>{t('consentRightsComplaint')}</li>
            </ul>
            
            <p className="mt-6">{t('consentConclusion')}</p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
